import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Selector from '../../components/forms/Selector';
import language from '../../variables/language';
import '../../css/modals.css';

const TEXT_FIELDS = [
   {name:'name', type:'text'},
   {name:'surname', type:'text'},
   {name:'email', type:'text'},
];
const SELECT_FIELDS = [
   {name:'responsibleId', url:'/api/users'},
   {name:'project', url:'/api/projects'},
];

const emptyValues = () => ({name:'', surname:'', email:'', responsibleId:'', project:''});

export default function StudentCreateModal({ isOpen, onClose, onCreated }) {
   const navigate = useNavigate();
   const [values, setValues] = useState(emptyValues());
   const [saving, setSaving] = useState(false);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleFieldChange = (name, value) => {
      setValues(prev => ({...prev, [name]: value}));
   }

   const handleClose = () => {
      setValues(emptyValues());
      onClose();
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving) return;
      setSaving(true);
      const payload = {};
      Object.keys(values).forEach(key => {
         if(values[key] !== '') {
            payload[key] = values[key];
         }
      });
      axios.post('/api/students', JSON.stringify(payload), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      }).then(() => {
         setValues(emptyValues());
         onCreated();
      }).catch(err => {
         if(err.response && err.response.status === 401){
            navigate('/login');
         }
         console.log(err);
      }).finally(() => {
         setSaving(false);
      });
   }

   return (
      <div className="modal-update" onClick={handleClose} style={{ display: 'flex' }}>
         <div className="modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">{language[language.lang].modals.students.createTitle}</h3>
            <form onSubmit={handleSubmit}>
               <div className='student-create-fields'>
                  {TEXT_FIELDS.map(f => (
                     <div className='flex-from-input-wraper student-create-field' data-label={language[language.lang][f.name]} key={f.name}>
                        <input className='submit-field from-input txt-c' type={f.type}
                           placeholder={language[language.lang][f.name]}
                           value={values[f.name]}
                           onChange={(e) => handleFieldChange(f.name, e.target.value)} />
                     </div>
                  ))}
                  {SELECT_FIELDS.map(f => (
                     <div className='flex-from-input-wraper student-create-field' data-label={language[language.lang][f.name]} key={f.name}>
                        <Selector className='submit-field form-selection txt-c'
                           name={f.name} url={f.url} value={values[f.name]} disabled={false}
                           selectorsHundler={(value) => handleFieldChange(f.name, value)} />
                     </div>
                  ))}
               </div>
               <button type='submit' className='form-button txt-c' disabled={saving} style={{marginTop:14}}>
                  {saving ? language[language.lang]['Loading ...'] : language[language.lang].save}
               </button>
            </form>
         </div>
      </div>
   );
}
